import cx from 'classnames';
import type { FC, ReactNode } from 'react';

import { Headline } from '@zen/DesignSystem';

export interface Props {
  className?: string;
  icon?: ReactNode;
  tagline?: ReactNode;
  title: ReactNode;
}

export const displayName: string = 'Components/PageTitle';

const PageTitle: FC<Props> = (props) => {
  const { className, icon, tagline, title } = props;
  const wrapperClassNames: string = cx({ 'flex items-start space-x-4': !!icon }, className);

  return (
    <div className={wrapperClassNames} data-testid="page-title">
      {icon && <div className="shrink-0">{icon}</div>}
      <div className="min-w-0">
        <Headline level={1}>{title}</Headline>
        {tagline && <div className="mt-3 text-sm font-normal leading-normal text-grey-base">{tagline}</div>}
      </div>
    </div>
  );
};

export type { Props as PageTitleProps };
export default PageTitle;
